import { sectionType } from '@/views/website/products/components/description/common/types';
export const IDENTIFIER_TAGS = {};
export default {
  crawlType: 'review_list',
  matchTemplates: [
    {
      type: sectionType.sectionProductReviews,
      tags: [],
      priority: 1,
    },
  ],
};
